/** Returns a list of entity ids without the version i.e. 123#456_v0 => [123,456]  */
export const getEntityIdsWithoutVersion = (id: string) =>
  id.split('#').map((idWithVersion) => idWithVersion.split('_')[0]);

/** Remove i.e. _v0 from an entity id i.e. 123#456_v0 => 123#456 */
export const getEntityIdWithoutVersion = (id: string) =>
  getEntityIdsWithoutVersion(id).join('#');
